// Gate for the CSR-only portal pages (inbox, sent, all emails, my salespeople,
// team, analytics).
//
// * An executive reader (exec:portal: PJ, Ravi) goes to the Initiative
//   Roadmap. They are ADMIN-role on production, so the admin short-circuit in
//   hasScope('orders:manage') used to let a stale bookmark or an admin
//   "View As" open the CSR inbox for them; the owner wants them on the roadmap
//   whenever they come to the portal (review rwusd8, 2026-09-28).
// * Anyone else without orders:manage goes to /portal/customers, as before.

import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { EXEC_PORTAL_HOME } from '../../constants/execPortal';
import { isExecPortalUser } from '../../utils/landingPage';

export function OrdersManagerRoute({ children }: { children: ReactNode }) {
  const { hasScope, user } = useAuth();
  if (user && isExecPortalUser(user)) {
    return <Navigate to={EXEC_PORTAL_HOME} replace />;
  }
  if (!hasScope('orders:manage')) {
    return <Navigate to="/portal/customers" replace />;
  }
  return <>{children}</>;
}
